import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

const PREFIX = constants.mobileRoutes;

/** List */
export const routesRequest = createRequest(PREFIX);
export const routesSuccess = createSuccess(PREFIX);
export const routesFailure = createFailure(PREFIX);

/** Detail */
export const detailRequest = createRequest(`${PREFIX}_DETAIL`);
export const detailSuccess = createSuccess(`${PREFIX}_DETAIL`);
export const detailFailure = createFailure(`${PREFIX}_DETAIL`);

/** Create */
export const createRouteRequest = createRequest(`${PREFIX}_CREATE`);
export const createRouteSuccess = createSuccess(`${PREFIX}_CREATE`);
export const createRouteFailure = createFailure(`${PREFIX}_CREATE`);

/** Update (full stops array diff-and-apply on the server) */
export const updateRouteRequest = createRequest(`${PREFIX}_UPDATE`);
export const updateRouteSuccess = createSuccess(`${PREFIX}_UPDATE`);
export const updateRouteFailure = createFailure(`${PREFIX}_UPDATE`);

/** Copy */
export const copyRouteRequest = createRequest(`${PREFIX}_COPY`);
export const copyRouteSuccess = createSuccess(`${PREFIX}_COPY`);
export const copyRouteFailure = createFailure(`${PREFIX}_COPY`);

/** Suspend */
export const suspendRouteRequest = createRequest(`${PREFIX}_SUSPEND`);
export const suspendRouteSuccess = createSuccess(`${PREFIX}_SUSPEND`);
export const suspendRouteFailure = createFailure(`${PREFIX}_SUSPEND`);

/** Resume */
export const resumeRouteRequest = createRequest(`${PREFIX}_RESUME`);
export const resumeRouteSuccess = createSuccess(`${PREFIX}_RESUME`);
export const resumeRouteFailure = createFailure(`${PREFIX}_RESUME`);

/** Delete */
export const deleteRouteRequest = createRequest(`${PREFIX}_DELETE`);
export const deleteRouteSuccess = createSuccess(`${PREFIX}_DELETE`);
export const deleteRouteFailure = createFailure(`${PREFIX}_DELETE`);

/** Run history (paginated) */
export const runsRequest = createRequest(`${PREFIX}_RUNS`);
export const runsSuccess = createSuccess(`${PREFIX}_RUNS`);
export const runsFailure = createFailure(`${PREFIX}_RUNS`);

/** Run detail */
export const runDetailRequest = createRequest(`${PREFIX}_RUN_DETAIL`);
export const runDetailSuccess = createSuccess(`${PREFIX}_RUN_DETAIL`);
export const runDetailFailure = createFailure(`${PREFIX}_RUN_DETAIL`);

/** All runs across routes (Operations "Mobile Route Runs" page) — GET /mobile-routes/runs */
export const runsListRequest = createRequest(`${PREFIX}_RUNS_LIST`);
export const runsListSuccess = createSuccess(`${PREFIX}_RUNS_LIST`);
export const runsListFailure = createFailure(`${PREFIX}_RUNS_LIST`);

/** Run detail by run id, route-context-free — GET /mobile-routes/runs/{runId} */
export const runByIdRequest = createRequest(`${PREFIX}_RUN_BY_ID`);
export const runByIdSuccess = createSuccess(`${PREFIX}_RUN_BY_ID`);
export const runByIdFailure = createFailure(`${PREFIX}_RUN_BY_ID`);

/** Friendly aliases for component dispatch sites (mirrors mobile-patrols/actions.js lines 50-60) */
export const requestRoutes = routesRequest;
export const requestRouteDetail = detailRequest;
export const createRoute = createRouteRequest;
export const updateRoute = updateRouteRequest;
export const copyRoute = copyRouteRequest;
export const suspendRoute = suspendRouteRequest;
export const resumeRoute = resumeRouteRequest;
export const deleteRoute = deleteRouteRequest;
export const requestRouteRuns = runsRequest;
export const requestRouteRunDetail = runDetailRequest;
export const requestAllRuns = runsListRequest;
export const requestRunById = runByIdRequest;
